// extracted by mini-css-extract-plugin
export default {"modalContent":"styles_modalContent__v2h3y","fullView":"styles_fullView__4LTba","shimmer":"styles_shimmer__X9RG3"};